export namespace FootprintsAction {
  /**
   * Action to get donations from api based on brand
   */
  export class LoadFootprintsDonations {
    public static readonly type = '[Footprints] Load Donations';

    constructor(public brand: string) {}
  }

  /**
   * Action to get Fundable projects
   */
  export class LoadFundableProjects {
    public static readonly type = '[Footprints] Load Fundable projects';

    constructor(public partnerCode: string, public countryCodes: string[]) {}
  }

  export class SetSelectedProject {
    public static readonly type = '[Footprints] Set selected project';
    constructor(public projectId: number) {}
  }

  export class SetSelectedDonationAmount {
    public static readonly type = '[Footprints] Set selected donation amount';
    constructor(public amount: number) {}
  }
}
